import { Injectable, inject } from '@angular/core';
import { Play } from '@r1-compass-library/models';
import { Dependency } from '@r1-compass-library/models/dependencies.model';
import { TemplateCriteria } from '@r1-compass-library/models/template-criteria/template-criteria.model';
import { TemplateCriteriaFolderService } from '@r1-compass-library/services/template-criteria-folder.service';
import { TemplateCriteriaService } from '@r1-compass-library/services/template-criteria.service';
import { AssetListState, AssetListStore } from '@r1-compass-library/store/asset-list.store';
import { forkJoin } from 'rxjs';
import { PlayService } from '@r1-compass-library/services';

@Injectable()
export class TemplateCriteriaListStore extends AssetListStore<
    TemplateCriteria,
    TemplateCriteriaService,
    TemplateCriteriaFolderService
> {
    readonly #playService = inject(PlayService);

    protected override initialState: AssetListState<TemplateCriteria> = {
        assets: [],
        folders: [],
        currentFolder: null,
        dependencies: undefined,
        message: undefined,
    };

    assetTypeName = 'Template Criteria Folder';

    constructor(
        templateCriteriaService: TemplateCriteriaService,
        templateCriteriaFolderService: TemplateCriteriaFolderService
    ) {
        super(templateCriteriaService, templateCriteriaFolderService);
    }

    protected override handleDependencies(assets: TemplateCriteria[]) {
        this.clearDependencies();
        forkJoin(assets.map(asset => this.#playService.search({ templateCriteriaId: asset.id }))).subscribe(plays => {
            this.setDependenciesForAssets(plays, assets);
        });
    }

    protected override buildDependencies(play: Play, assets: TemplateCriteria[]): Dependency[] {
        return [
            {
                assetId: play.templateCriteriaId,
                playId: play.id,
                name: play.name,
            },
        ];
    }
}
